var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border",class:_vm.getClass,style:(_vm.getChildStyle)},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}
var staticRenderFns = []

export { render, staticRenderFns }